import { mapKeys } from 'lodash'

const translations = import.meta.glob<Record<string, string>>('./*.json', { eager: true })

export default mapKeys(translations, (_value, key) => key.slice(2, -5))
